var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survey-cake-page",class:{ 'pdf-mode': _vm.isPDF }},[_c('img',{staticClass:"end-page",attrs:{"src":require("@/assets/survey-cake/end-page.jpg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }